import React from 'react';
import { TextStyle } from 'react-native';
import ViewMoreText from 'react-native-view-more-text';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import { Body1 } from '@src/components/Typography';

type Props = {
  children: React.ReactNode;
  style?: TextStyle;
};

const More = styled(Body1)`
  color: ${({ theme }) => theme.colors.primary};
`;

const Component: React.FC<Props> = ({ children, style }) => {
  const renderTruncatedFooter = React.useCallback(
    (onPress: () => void) => (
      <More style={style} onPress={onPress}>
        {/* <Trans>More</Trans> */}
      </More>
    ),
    [style]
  );

  const renderRevealedFooter = React.useCallback(
    (onPress: () => void) => (
      <More style={style} onPress={onPress}>
        {/* <Trans>Less</Trans> */}
      </More>
    ),
    [style]
  );

  return (
    <ViewMoreText
      numberOfLines={4000}
      renderViewMore={renderRevealedFooter}
      renderViewLess={renderRevealedFooter}
      textStyle={style}
    >
      {children}
    </ViewMoreText>
  );
};

Component.displayName = 'ReadMoreContent';

export default Component;
